export default __webpack_public_path__ + "static/media/jm.c8d51bb6.svg";